import Query from '@/services/query'

import { VUE_APP_ROOT_API } from '@/helpers/env'

export default {
  sendImage: async function(file) {
    let data = new FormData()
    let fileExtension = file.name.substring(file.name.indexOf('.'))

    data.append('file', file, `image${fileExtension}`)
    const response = await Query.post(`${VUE_APP_ROOT_API}/uploadapi/uploadimage`, data)
    if (response.status === 200) {
      return await response.json()
    } else {
      throw new Error("Une erreur s'est produite pendant la sauvegarde de l'image")
    }
  }
}
